import React, { useEffect, useState } from 'react';
import Logo from "../assets/logo_bckTransparent.png";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  //MDBNavbarItem,
  MDBNavbarLink,
  MDBIcon,
  MDBCollapse
} from 'mdb-react-ui-kit';
import { useWindowSize } from "@uidotdev/usehooks";
import NavDropdown from 'react-bootstrap/NavDropdown';

//burger
import Burger from "../functions/Burger/Burger";
import Menu from "../functions/Burger/Menu";


const useOnClickOutside = (ref, handler) => {
  React.useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener("mousedown", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};
// end burger


function Browser({ size }) {
  return (
    <div
      data-testid="browser"
      className="browser"
      style={{ width: size.width / 4, height: size.height / 4 }}
    />
  );
}

export default function Navigation() {
  const [showNavSecond, setShowNavSecond] = useState(false);
  const [brandType, setBrandType] = useState("1")
  const size = useWindowSize();
  
  //burger
  const [open, setOpen] = React.useState(false);
  const node = React.useRef();
  useOnClickOutside(node, () => setOpen(false));  
  //end burger
  

  return (
    <MDBNavbar fluid className="myNavBar" expand="lg">   
      <img src={Logo} id="logo" className="px-2" />         
      <div id="myCollapse"> 
          <MDBNavbarLink className="navMenuText mx-2 px-2" href="#Contatti">
            Contatti
          </MDBNavbarLink> 
          <MDBNavbarLink className="navMenuText mx-2 px-2" href="#foto">
            Foto
          </MDBNavbarLink>  
          <MDBNavbarLink className="navMenuText mx-2 px-2" href="#trattamenti">
            Trattamenti
          </MDBNavbarLink>  
          {/*<NavDropdown className="navMenuText mx-2 px-2 py-0" title="Trattamenti">            
              <NavDropdown.Item href="#" className="navMenuText2">
                trattamento1
              </NavDropdown.Item>
              <NavDropdown.Item href="#" className="navMenuText2">
                trattamento2
              </NavDropdown.Item>
              <NavDropdown.Item href="#" className="navMenuText2">
                trattamento3
              </NavDropdown.Item>
              <NavDropdown.Item href="#" className="navMenuText2">
                trattamento4
              </NavDropdown.Item>            
          </NavDropdown>*/}    
      </div>      
      <div className="myMenu" ref={node}>
        <Burger open={open} setOpen={setOpen} />
        <Menu open={open} setOpen={setOpen} />
      </div>
    </MDBNavbar>
    
  );
}


